export default "__VITE_ASSET__BpoiaqWw__"